import { styled } from '@mui/material/styles';

export interface ProductTypeWrapperProps {
  withProductTypeName: boolean;
}

const styledProductTypeWrapperOptions = {
  shouldForwardProp: (prop: string) => !['withProductTypeName'].includes(prop),
};

export const StyledProductTypeWrapper = styled(
  'div',
  styledProductTypeWrapperOptions,
)<ProductTypeWrapperProps>(({ withProductTypeName }) => ({
  marginBottom: withProductTypeName ? '24px' : '16px',
}));
